<template>
  <span class="more-button"><slot></slot></span>
</template>

<script>
export default {
  name: 'MoreButton',

  data () {
    return {
    }
  },

  methods: {
  }
}
</script>

<style>

</style>
